import { keepPreviousData } from '@tanstack/react-query';

/** Cache axis preview responses so reopening settings with the same config skips refetch. */
export const WHITESPACE_AXIS_PREVIEW_STALE_TIME_MS = 5 * 60 * 1000;

export const WHITESPACE_AXIS_PREVIEW_QUERY_OPTIONS = {
    staleTime: WHITESPACE_AXIS_PREVIEW_STALE_TIME_MS,
    gcTime: WHITESPACE_AXIS_PREVIEW_STALE_TIME_MS,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
} as const;
